var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrcodeFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 166 158",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 67,
    y1: 2.5,
    y2: 2.5,
    strokeWidth: 5,
    className: "svgStroke"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 67,
    x2: 2.5,
    strokeWidth: 5,
    className: "svgStroke"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 2.5,
    y1: 91,
    x2: 2.5,
    y2: 158,
    strokeWidth: 5,
    className: "svgStroke"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 67,
    y1: 155.5,
    y2: 155.5,
    strokeWidth: 5,
    className: "svgStroke"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 67,
    y2: -2.5,
    transform: "matrix(1 0 0 -1 99 0)",
    strokeWidth: 5,
    className: "svgStroke"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 67,
    y2: -2.5,
    transform: "matrix(0 -1 -1 0 161 67)",
    strokeWidth: 5,
    className: "svgStroke"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 67,
    y2: -2.5,
    transform: "matrix(0 1 1 0 166 91)",
    strokeWidth: 5,
    className: "svgStroke"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    y1: -2.5,
    x2: 67,
    y2: -2.5,
    transform: "matrix(1 0 0 -1 99 153)",
    strokeWidth: 5,
    className: "svgStroke"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrcodeFrame);
export default __webpack_public_path__ + "static/media/qrcodeFrame.7e9a1d18.svg";
export { ForwardRef as ReactComponent };